// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c3db42c8","239":"d5dd6a86","455":"d9162ca8","977":"e141c58e"}[chunkId] + ".chunk.js";
};